import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'vehicles'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
})
  AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 60,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-car2',
  permission: 'vehicles.index',
  children: [
    {
      id: `${base}`,
      text($vm) {
        return $vm.$t(`${base}.title`)
      },
      icon: 'icon-car2',
      route: {
        name: `${base}`,
      },
    },
    {
      id: 'vehicles.vehicle-types',
      text: ($vm) => $vm.$t('vehicles.vehicle_types.title'),
      icon: 'icon-car2',
      route: {
        name: 'vehicle-types',
      },
      permission: 'administer'
    },
  ]
})

messageGroups.push(base)
messageGroups.push('rate')
